import { Game } from 'functions/src/types/firestore/Game';
import { CurrencyOptions } from '../../contexts/CurrencyContext';
import { getDefaultFilterOptions } from './filter-options/default';
import { getGameFilterOptions } from './filter-options/games';
import { getInventoryFilterOptions } from './filter-options/inventory';
import { getLikedFilterOptions } from './filter-options/liked';

type GetFilterOptionsParams = {
  parent: 'inventory' | 'game' | 'liked';
  currencyOptions: CurrencyOptions;
} & Pick<Game, 'title'>;

export const getFilterOptions = (params: GetFilterOptionsParams) => {
  const { parent, currencyOptions, title } = params;
  switch (parent) {
    case 'inventory':
      return getInventoryFilterOptions(currencyOptions);
    case 'game':
      return getGameFilterOptions(title, currencyOptions);
    case 'liked':
      return getLikedFilterOptions(currencyOptions);
    default:
      return getDefaultFilterOptions(currencyOptions);
  }
};
